var map = {
	"./Arrow.webp": 304,
	"./Cake.webp": 840,
	"./Default.webp": 895,
	"./Running.webp": 351,
	"./Sea.webp": 55,
	"./Smiling.webp": 795,
	"./small/ArrowS.webp": 859,
	"./small/CakeS.webp": 509,
	"./small/RunningS.webp": 63,
	"./small/SeaS.webp": 532,
	"./small/SmilingS.webp": 489
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 242;